import { useEffect, useState } from 'react';
import { getAbTestV2 } from 'dibs-buyer-layout/exports/clientABTestV2';
import { ENHANCED_BUYER_INCENTIVES } from '../../constants/abTestsConstants';

export const useEnhancedBuyerIncentivesClientVariant = (): boolean | null => {
    const [isEnhancedBuyerIncentivesClient, setIsEnhancedBuyerIncentivesClient] = useState<
        boolean | null
    >(null);

    useEffect(() => {
        setIsEnhancedBuyerIncentivesClient(
            getAbTestV2(ENHANCED_BUYER_INCENTIVES)?.variant === 'variant'
        );
    }, []);

    return isEnhancedBuyerIncentivesClient;
};
